var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { Field, Input, PasswordRulesPopover, SubmitButton } from "../../components/components.js";
import { useResetPassword } from "../../core/auth.js";
import { filterChinese, isEmail, validatePassword } from "../../core/password.js";
import { useEmailCode } from "../../hooks/useEmailCode.js";
import { isMobile } from "../../utils.js";
import { createPasswordValidator } from "../password-rules.js";
export const ForgotForm = ({ config, locale, options, setAction, showToast, t }) => {
    const isH5 = isMobile();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [code, setCode] = useState("");
    const [loading, resetPasswordApi] = useResetPassword();
    const isDisabled = useMemo(() => !(email.trim() && code.trim() && password.trim() && password2.trim()), [email, code, password, password2]);
    const { count, sendCode } = useEmailCode({
        t,
        action: "forgot",
        email,
        locale,
        showError: showToast,
    });
    const submit = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!isEmail(email)) {
            showToast(t("forgot.validEmail"));
            return;
        }
        const passwordError = validatePassword(password);
        if (passwordError) {
            showToast(t(passwordError === "length" ? "passwordRules.length_error" : "passwordRules.composition"));
            return;
        }
        if (password !== password2) {
            showToast(t("forgot.newPassword_error2"));
            return;
        }
        yield resetPasswordApi({
            values: { email, password, verifyCode: code, locale, source: (_a = config.source) !== null && _a !== void 0 ? _a : "" },
            onSuccess: (_result) => {
                var _a;
                (_a = options.onForgotSuccess) === null || _a === void 0 ? void 0 : _a.call(options);
                showToast({
                    type: "success",
                    content: t("forgot.resetSuccess"),
                });
                setAction("login");
            },
            onError: (error) => {
                var _a;
                showToast({
                    type: "error",
                    content: error,
                });
                (_a = options.onError) === null || _a === void 0 ? void 0 : _a.call(options, { message: error });
            },
        });
    });
    return (_jsxs(_Fragment, { children: [_jsxs("h2", { className: "modalTitle modal", children: [" ", t("forgot.title")] }), _jsx(Field, { label: t("forgot.emailAddress"), rules: [
                    { required: true, message: t("forgot.requireEmail") },
                    { type: "email", message: t("forgot.validEmail") },
                ], children: _jsx(Input, { placeholder: t("forgot.emailAddress"), value: email, autoFocus: true, onChange: (value) => setEmail(value.trim()) }) }), _jsx(Field, { label: t("forgot.emailCode"), rules: [{ required: true, message: t("forgot.requireCode") }], children: _jsxs("div", { className: "smm-auth-input-row", children: [_jsx(Input, { placeholder: t("forgot.emailCode"), value: code, onChange: (value) => setCode(value.trim()) }), _jsx("button", { className: "smm-auth-send", type: "button", "data-smm-auth-tab-stop": "true", disabled: !email || count > 0 || loading, onClick: sendCode, children: count > 0 ? `${t("forgot.resend")}(${count}${t("forgot.s")})` : t("forgot.send") })] }) }), _jsx(Field, { label: t("forgot.newPassword"), rules: [{ required: true, message: t("forgot.requirePassword") }, { validator: createPasswordValidator(t) }], children: _jsx(PasswordRulesPopover, { t: t, children: _jsx(Input, { placeholder: t("forgot.newPassword"), type: "password", value: password, transformValue: filterChinese, onChange: setPassword }) }) }), _jsx(Field, { label: t("forgot.confirmPassword"), rules: [
                    { required: true, message: t("forgot.requireConfirmPassword") },
                    {
                        validator: (value) => (!value || value === password ? undefined : t("forgot.newPassword_error2")),
                    },
                ], children: _jsx(Input, { placeholder: t("forgot.confirmPassword"), type: "password", value: password2, transformValue: filterChinese, onChange: setPassword2 }) }), isH5 && _jsx("div", { className: "simplePasswordTip", children: t("forgot.simplePasswordTip") }), _jsx(SubmitButton, { style: { marginTop: 16 }, disabled: isDisabled, loading: loading, onClick: submit, children: t("forgot.reset") })] }));
};
//# sourceMappingURL=index.js.map